export interface IFlags {
	hasElec: boolean;
	hasGas: boolean;
}

export const emptyFlags: IFlags = {
	hasElec: false,
	hasGas: false
};
